import widgetsMgr from 'widgets/widgetsMgr';

import GoogleRecaptcha from './widgets/forms/GoogleRecaptcha';
import AjaxFormWithRecaptcha from './widgets/forms/AjaxFormWithRecaptcha';

widgetsMgr.addWidgetsList('google.recaptcha.global.widgets', () => [
    ['ajaxform', AjaxFormWithRecaptcha, 'ajaxform'],
    ['googleRecaptcha', GoogleRecaptcha, 'inputHidden']
]);
